import { Navigate, Outlet, createBrowserRouter } from 'react-router-dom';
import { RouteErrorElement } from '@/components/error-fallback';
import { ROUTES } from '@/constants';
import { privateRoutes } from './private.routes';
import { publicRoutes } from './public.routes';

const routes = () => {
  return createBrowserRouter(
    [
      {
        path: ROUTES.base,
        element: <Outlet />,
        errorElement: <RouteErrorElement />,
        children: [
          {
            index: true,
            element: <Navigate replace to={ROUTES.login} />,
          },

          {
            path: ROUTES.base,
            children: publicRoutes(),
          },

          {
            path: ROUTES.admin,
            children: privateRoutes(),
          },
        ],
      },
    ],
    {
      future: {
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_relativeSplatPath: true,
        v7_skipActionErrorRevalidation: true,
        v7_startTransition: true,
      },
    }
  );
};

export default routes;
